import React, { Component } from 'react'
import classnames from 'classnames'
import { Header } from 'semantic-ui-react'
import './style.css'

export default class NotFound extends Component {
  render() {
    const { className } = this.props
    return (
      <div className={classnames('NotFound', className)} >
        <Header as="h1">Not Found :(</Header>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/index.jsx